import { render, staticRenderFns } from "./PaginaPunteggiMinistero.vue?vue&type=template&id=29e9fc3c"
import script from "./PaginaPunteggiMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaPunteggiMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaPunteggiMinistero.vue?vue&type=style&index=0&id=29e9fc3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports